import * as BiIcons from "react-icons/bs";
import {Button, Modal} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import "../../static/css/help-dialog.css";

interface HelpDialogProps {
    open?: boolean,
    onClose?: () => void
}

const HelpDialog = ({open, onClose}: HelpDialogProps) => {
    const { t } = useTranslation();

    return (
        <Modal show={open} onHide={onClose} className="short_cut_modal">
            <Modal.Header className="border-bottom-0 float-end">
                <Button type="button" variant="white" className="btn-close" onClick={onClose}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center mb-4">
                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            <h4 className="text-primary">{t("terminal.window")}</h4>
                            <hr/>
                            <div className="modal-name">
                                <div>
                                    <p>{t("terminal.openNewTab")}</p>
                                    <p>{t("terminal.closeCurrentTab")}</p>
                                    <p>{t("terminal.previousTabActive")}</p>
                                    <p>{t("terminal.nextTabActive")}</p>
                                </div>
                            </div>
                            <div className="modal-command">
                                <div>
                                    <p>Alt + T</p>
                                    <p>Alt + W</p>
                                    <p>Alt + PageUp</p>
                                    <p>Alt + PageDown</p>
                                </div>
                            </div>
                            <div className="cusion">&nbsp;</div>
                            <h4 className="text-primary">{t("terminal.edit")}</h4>
                            <hr/>
                            <div className="modal-name">
                                <div>
                                    <p>{t("terminal.find")}</p>
                                    <p>{t("terminal.copy")}</p>
                                    <p>{t("terminal.paste")}</p>
                                </div>
                            </div>
                            <div className="modal-command">
                                <div>
                                    <p>Ctrl + Shift + F</p>
                                    <p>Ctrl + Shift + C</p>
                                    <p>
                                        <span className="me-3 text-primary">
                                            <BiIcons.BsBrowserChrome size="12"/>&nbsp;Chrome
                                        </span>
                                        Ctrl + Shift + V</p>
                                    <p>
                                        <span className="me-4 text-primary">
                                            <BiIcons.BsBrowserFirefox size="12"/>&nbsp;Firefox
                                        </span>
                                        Shift + Insert
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default HelpDialog;